import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const [isVerified, setIsVerified] = useState(null);
  const location = useLocation();

  useEffect(() => {
    verifyToken();
  }, []);

  const verifyToken = async () => {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      setIsVerified(false);
      return;
    }

    try {
      const res = await fetch(`${API}/admin/verify`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.ok) {
        setIsVerified(true);
      } else if (res.status === 401) {
        // Only remove token if server explicitly says it's invalid
        localStorage.removeItem("adminToken");
        setIsVerified(false);
      } else {
        // For other errors (500, etc.), assume token is still valid
        // This prevents logout on temporary server issues
        setIsVerified(true);
      }
    } catch (err) {
      // Network error - don't remove token, assume still valid
      // This prevents logout on temporary connection issues
      console.warn("Token verification failed due to network error, assuming valid");
      setIsVerified(true);
    }
  };

  if (isVerified === null) {
    return (
      <div className="loading-page">
        <p>Verifying authentication...</p>
      </div>
    );
  }

  if (!isVerified) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  return children;
}
